import type { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  narrow?: boolean;
}

/**
 * Page content container with sensible max-width + padding.
 * Use `narrow` for legal / textual pages.
 */
export default function Container({ children, narrow = false }: ContainerProps) {
  return (
    <div className={`page-shell mx-auto px-6 py-20 ${narrow ? 'max-w-3xl' : 'max-w-5xl'}`}>
      {children}
    </div>
  );
}
